import { Link } from 'react-router-dom';
import { Button } from 'antd';

import BannerImage from '../../jpeg/pages/free-audit/2.jpg';

import { MidBannerContainer } from './mid-banner.styles';

const MidBanner = ({title, text, buttonText, whatToDo }) => {
    return (
        <MidBannerContainer>
            <div  style={{
                height: 'calc(var(--vh, 1vh) * 60)',
                backgroundImage: `url(${BannerImage}), url(${BannerImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center top 40%',
                backgroundSize: 'cover',
                // color: `${det.color}`
            }}>
                
            </div>
          
        </MidBannerContainer>
    )
}

export default MidBanner;